import { createRouter, createWebHistory } from 'vue-router';

const Dashboard = () => import('./views/DashboardView.vue');
const Login = () => import('./views/LoginView.vue');
const Workspace = () => import('./views/WorkspaceView.vue');
const Analysis = () => import('./views/AnalysisView.vue');
const Reports = () => import('./views/ReportsView.vue');
const Tasks = () => import('./views/TasksView.vue');
const Favorites = () => import('./views/FavoritesView.vue');
const Paper = () => import('./views/PaperView.vue');
const Admin = () => import('./views/AdminView.vue');
const Stock = () => import('./views/StockView.vue');
const Legal = () => import('./views/LegalView.vue');

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (to) => to.hash
    ? { el: to.hash, top: 72, behavior: 'smooth' }
    : { top: 0 },
  routes: [
    { path: '/research', name: 'research', component: () => import('./views/ResearchLabView.vue') },
    { path: '/stock-research', name: 'stock-research', component: () => import('./views/StockResearchView.vue'), meta: { auth: true } },
    { path: '/', name: 'dashboard', component: Dashboard },
    { path: '/stocks/:code', name: 'stock', component: Stock },
    { path: '/login', name: 'login', component: Login },
    { path: '/terms', name: 'terms', component: Legal, meta: { legalDocument: 'terms' } },
    { path: '/privacy', name: 'privacy', component: Legal, meta: { legalDocument: 'privacy' } },
    { path: '/risk-disclosure', name: 'risk-disclosure', component: Legal, meta: { legalDocument: 'risk' } },
    { path: '/workspace', name: 'workspace', component: Workspace, meta: { auth: true } },
    { path: '/analysis', name: 'analysis', component: Analysis, meta: { auth: true } },
    { path: '/reports', name: 'reports', component: Reports, meta: { auth: true } },
    { path: '/tasks', name: 'tasks', component: Tasks, meta: { auth: true } },
    { path: '/favorites', name: 'favorites', component: Favorites, meta: { auth: true } },
    { path: '/paper', name: 'paper', component: Paper, meta: { auth: true } },
    { path: '/admin', name: 'admin', component: Admin, meta: { auth: true, admin: true } },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
});
